import React, { useEffect, useState } from "react";
//img
import profileImg from "../../../assets/images/png/Profile.png";
import plusIcon from "../../../assets/images/svg/plusIcon.png";
//css
import classes from "./VendorsTab.module.css";
//img
import successPopupImg from "../../../assets/images/png/Group 2 2@2x.png";
import deletePopupImg from "../../../assets/images/png/Group 2@2x.png";
import noImageAvailable from "../../../assets/images/png/no-image-available.png";
//components
import SearchBar from "../../../components/common/SearchBar/SearchBar";
import DateBar from "../../../components/common/DateBar/DateBar";
import NotificationBell from "../../../components/common/NotificationBell/NotificationBell";
import ProfileCard from "../../../components/common/ProfileCard/ProfileCard";
import HeaderTitle from "../../../components/common/HeaderTitle/HeaderTitle";
import PaginationComponent from "../../../components/common/Pagination/PaginationComponent";
import DButton from "../../../components/Dashboard/DashboardButtons/Dbutton";
import DataTable from "../../../components/common/DataTable/DataTableSorting";
import { Box, Button, Fade, Modal } from "@mui/material";
import DTextInput from "../../../components/Dashboard/DashboardInputs/DTextInput";
import DButtonOutlined from "../../../components/Dashboard/DashboardButtons/dButtonOutlined";
import PopupFrame from "../../../components/Popups/PopupFrame/PopupFrame";
import InfoLabel from "../../../components/common/InfoLabel/InfoLabel";
import { ArrowLeft } from "@mui/icons-material";
import DetailsTab from "../../../components/Dashboard/DetailsTab/DetailsTab";
import ImageView from "../../../components/Dashboard/ImageView/ImageView";
//api and redux
import { API_ENDPOINT } from "../../../services/api/resources";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { setVendorsData } from "../../../features/VendorDataSlice";
import SuccessPopupDashboard from "../../../components/Popups/PopupFrame/SuccessPopupDashboard";
import {
  emptyCheck,
  validateEmail,
  validateFile,
} from "../../../utils/validations";
import { nextPageClick, previouPageClick } from "../../../utils/pagination";
//custom hooks
import useFetchData from "../../../hooks/useFetchData";
import DFreeSoloInput from "../../../components/Dashboard/DashboardInputs/DFreeSoloInput";
import { getUniqueData } from "../../../utils/getUniqueData";
import DropdownBtnOutlined from "../../../components/Dashboard/DropdownButtons/DropdownBtnOutlined/DropdownBtnOutlined";
import { downloadFile } from "../../../utils/downloadFile";
import Dbutton from "../../../components/Dashboard/DashboardButtons/Dbutton";
import DefaultLabel from "../../../components/Dashboard/DefaultLabel/DefaultLabel";
import DFileUpload from "../../../components/Dashboard/DashboardInputs/DFileUpload";
import sampleCSV from "../../../assets/files/Sample Vendor CSV.xlsx";
import { saveAs } from "file-saver";
import JSZip from "jszip";
import Tooltip from "@mui/material/Tooltip";
import { useLocation } from "react-router-dom";
import VendorItemMapping from "./VendorItemMapping";

const formatDate = (isoDate) => {
  if (!isoDate) return "NA";
  const date = new Date(isoDate);
  return date.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

const BuyerVendorsTab = () => {
  //view vendor flag
  const [vendorMain, setVendorMain] = useState(true);
  const [openViewVendor, setOpenViewVendor] = useState(false);
  const [iseditable, setiseditable] = useState(true);
  //pagenumber
  const [pageNumber, setPageNumber] = useState(1);
  //pagination data
  const [paginationData, setPaginationData] = useState();
  const Datas = useSelector((state) => state.loginData.value);
  const location = useLocation();

  const [tab1, setTab1] = useState(false);
  const [tab2, setTab2] = useState(false);
  const [tab3, setTab3] = useState(false);
  const [tab4, setTab4] = useState(false);
  const [tab5, setTab5] = useState(true);
  const [tab6, setTab6] = useState(false);
  const [tab7, setTab7] = useState(false);
  const [tab8, setTab8] = useState(false);

  const tab1Click = () => {
    setTab1(true);
    setTab2(false);
    setTab3(false);
    setTab4(false);
    setTab5(false);
    setTab6(false);
    setTab7(false);
    setTab8(false);
  };

  const tab2Click = () => {
    setTab1(false);
    setTab2(true);
    setTab3(false);
    setTab4(false);
    setTab5(false);
    setTab6(false);
    setTab7(false);
    setTab8(false);
  };

  const tab3Click = () => {
    setTab1(false);
    setTab2(false);
    setTab3(true);
    setTab4(false);
    setTab5(false);
    setTab6(false);
    setTab7(false);
    setTab8(false);
  };

  const tab4Click = () => {
    setTab1(false);
    setTab2(false);
    setTab3(false);
    setTab4(true);
    setTab5(false);
    setTab6(false);
    setTab7(false);
    setTab8(false);
  };

  const tab5Click = () => {
    setTab1(false);
    setTab2(false);
    setTab3(false);
    setTab4(false);
    setTab5(true);
    setTab6(false);
    setTab7(false);
    setTab8(false);
  };

  const tab6Click = () => {
    setTab1(false);
    setTab2(false);
    setTab3(false);
    setTab4(false);
    setTab5(false);
    setTab6(true);
    setTab7(false);
    setTab8(false);
  };

  const tab7Click = () => {
    setTab1(false);
    setTab2(false);
    setTab3(false);
    setTab4(false);
    setTab5(false);
    setTab6(false);
    setTab7(true);
    setTab8(false);
  };

  const tab8Click = () => {
    setTab1(false);
    setTab2(false);
    setTab3(false);
    setTab4(false);
    setTab5(false);
    setTab6(false);
    setTab7(false);
    setTab8(false);
    setTab8(true);
  };

  //dispatcher
  const dispatch = useDispatch();

  //get data from use selector
  const data = useSelector((state) => state.loginData.value);
  const vendorsData = useSelector((state) => state.vendorsData.value);
  console.log(vendorsData);

  //popuptext
  const [popupHeroText, setPopupHeroText] = useState("");
  const [popupImage, setPopupImage] = useState(successPopupImg); // dynamic success/alert image

  //search filtered data
  // const [searchQuery, setSearchQuery] = useState("");
  const [searchQuery, setSearchQuery] = useState(() => {
    return localStorage.getItem("vendor_name") || "";
  });

  //unique user
  const [uniqueData, setUniqueData] = useState();
  console.log(uniqueData);
  const [uniqueLocalData, setUniqueLocalData] = useState();
  const [uniqueDataID, setUniqueDataID] = useState("");
  const[vendorUserToken,setVendorUserToken]=useState("")

  //credentials
  const [auth_token, setAuthToken] = useState(data?.auth_token);
  const [organization_token, setOrganizationToken] = useState(data?.organization_token);
  const [org_token, setOrg_token] = useState(data?.user?.token);
  const [popupMessage, setPopupMessage] = useState("");
  
  //pagination logics
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = paginationData?.current_page_count;
  const totalItems = paginationData?.page_count;
  const vendorContactRole = uniqueLocalData?.role !== "vendor contact";
  const [tableProps, setTableProps] = useState({
    isLoading: false,
    errorMessage: "",
  });
  // error message
  const [primaryBtnError, setPrimaryBtnError] = useState({
    error: false,
    errorMsg: "",
  });
  // loading state
  const [loadingState, setLoadingState] = useState(false);
  const [loadingStateDwnload, setLoadingStateDwnload] = useState(false);

  const [sortingColumnName, setSortingColumnName] = useState(null);
  const [sortingOrder, setSortingOrder] = useState(null);
  const order =
    sortingOrder === null || sortingOrder === "asc" ? "desc" : "asc";

  const [selectedDocs, setSelectedDocs] = useState([]);

  // ===== Vendor limit guard (based on plan/vendor_count) =====
  const vendorPlanLimit = Datas?.vendor_count ?? 0;

  const getTotalVendors = () => {
    const p = paginationData || {};
    // Try common keys; fallback to table data length if only first page available
    return (
      p.total_records ??
      p.total_items ??
      p.total_count ??
      p.total ??
      p.count ??
      vendorsData?.total_records ??
      vendorsData?.length ??
      0
    );
  };

  const atVendorLimit =
    vendorPlanLimit > 0 && getTotalVendors() >= vendorPlanLimit;

  const guardLimitAndShow = () => {
    if (!atVendorLimit) return false;
    setPopupHeroText("Vendor limit reached");
    setPopupMessage(
      `Your account can have up to ${vendorPlanLimit} vendors. Current vendors: ${getTotalVendors()}.`
    );
    setPopupImage(deletePopupImg); // alert style
    setOpenS(true);
    return true;
  };
  // ==========================================================

  const GetAllData = () => {
    useFetchData({
      pageNumber: pageNumber,
      endpoint: `${API_ENDPOINT.get_all_vendor}`,
      idName: "org_token",
      idValue: org_token,
      searchQuery: searchQuery,
      ...(sortingColumnName && { sortingColumnName: sortingColumnName }),
      ...(sortingOrder && { sortingOrder: order }),
      auth_token: auth_token,
      setData: setVendorsData,
      setPaginationData: setPaginationData,
      dispatch: dispatch,
      tableProps,
      setTableProps,
    });
  };

  let delay = 300;

  //get users data for table view
  useEffect(() => {
    let timeoutId = null;
    timeoutId = setTimeout(() => {
      if (pageNumber) {
        GetAllData();
      }
    }, delay);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [pageNumber, searchQuery, sortingColumnName, sortingOrder]);

  //get unique data
  const getIndividualData = async (unique_id, idKey) => {
    setLoadingState(true);
    await axios({
      method: "POST",
      url: `${API_ENDPOINT.get_individual_vendor}${idKey}=${unique_id}`,
      headers: {
        Authorization: `Bearer ${auth_token} `,
      },
    })
      .then((res) => {
        setLoadingState(false);

        let responseData = { ...res?.data?.users, ...res?.data?.admin };
        

        setUniqueData(responseData);

        const userData = res?.data?.users;
        setVendorUserToken(userData?.user_token)
      })
      .catch((err) => {
        setLoadingState(false);
        console.log(err);
      });
  };

  const reverifyVendor = async (vendorEmail) => {
    try {
      await axios.post(
        API_ENDPOINT.trigger_status_email,
        {
          official_email_address: vendorEmail,
        },
        {
          headers: { Authorization: `Bearer ${auth_token}` },
        }
      );

      setPopupHeroText("Reverify request sent!");
      setPopupMessage("Vendor verification has been re-initiated.");
      setPopupImage(successPopupImg);
      setOpenS(true);

      GetAllData();
    } catch (error) {
      console.error(error);
    }
  };

  const headings = [
    {
      label: "Company Name",
      field: `company_name`,
      additional_data: "full_profile",
    },
    { label: "Contact Person", field: `full_name` },
    { label: "Role", field: `role` },
    { label: "Contact Number", field: `official_mobile_number` },
    { label: "Invite Email", field: "invite_email_address" },
    { label: "Registered Email", field: "official_email_address" },
    { label: "Vendor Code", field: "vendor_code" },
    { label: "Created Date", field: "created_on" },
    {
      label: "Onboarding Status",
      field: "onboarding_status",
      customCell: true,
    },
    { label: "Reverify", field: "reverify_action", customCell: true },
  ];

  // const getOnboardingStatus = (vendor) => {
  //   console.log(vendor)
  //   const isPan = vendor?.pan_status === "Verified";
  //   const isGst = vendor?.gst_status === "Verified";
  //   const isCin = vendor?.cin_status === "Verified";
  //   const isCheque = vendor?.bank_status === "Verified";
  //   const isMsme = vendor?.msme_status === "Verified";

  //   if (isPan && isGst && isCheque && isMsme && isCin) {
  //     return "Fully Onboarded";
  //   }
  //   return "Partially Onboarded";
  // };

  const getOnboardingStatus = (vendor) => {
    console.log(vendor);
    const isPan = vendor?.pan_status === "Verified";
    const isGst = vendor?.gst_status === "Verified";
    const isCheque = vendor?.bank_status === "Verified";

    const isCin =
      !vendor?.cin_status ||
      vendor?.cin_status === "Verified" ||
      vendor?.cin_status === "";
    const isMsme =
      !vendor?.msme_status ||
      vendor?.msme_status === "Verified" ||
      vendor?.msme_status === "";

    const hasCinMismatch =
      vendor?.cin_status && vendor?.cin_status === "Mismatch";
    const hasMsmeMismatch =
      vendor?.msme_status && vendor?.msme_status === "Mismatch";

    if (isPan && isGst && isCheque && !hasCinMismatch && !hasMsmeMismatch) {
      return "Fully Onboarded";
    }
    return "Partially Onboarded";
  };

  //deletion popups and functions
  const deleteVendor = async () => {
    setLoadingState(true);
    await axios({
      method: "POST",
      url: `${API_ENDPOINT.delete_vendor}`,
      data: {
        buyer_token: data?.user?.token,
        vendor_token: uniqueDataID,
      },
      headers: {
        Authorization: `Bearer ${auth_token}`,
      },
    })
      .then((res) => {
        setLoadingState(false);
        GetAllData();
        handleCloseDltConfirmation();
        setPopupHeroText("Vendor has been Deleted!");
        setPopupMessage(res?.data?.response);
      })
      .catch((err) => {
        setLoadingState(false);
        console.log(err);
        setPopupHeroText("Something went wrong!");
        setPopupMessage(err?.response?.data?.response);
      });
  };

  //delete data
  const [openDlt, setOpenDlt] = useState(false);
  const handleOpenDlt = () => setOpenDlt(true);
  const handleCloseDlt = () => {
    setOpenDlt(false);
  };

  const [openDltConfirmation, setOpenDltConfirmation] = useState(false);

  const handleOpenDltConfirmation = (deletion_id, rowData) => {
    setOpenDltConfirmation(true);
    let uniqueRowData = getUniqueData(vendorsData, "token", deletion_id);
    setPopupHeroText(
      `Are you sure want to delete "${uniqueRowData?.full_name}"?`
    );
    setUniqueData(uniqueRowData);
    setPopupMessage("Heads up! deletion can't be undone.");
    setUniqueDataID(rowData?.token);
  };

  const handleCloseDltConfirmation = () => {
    setOpenDltConfirmation(false);
  };

  const handleDeleteVendor = () => {
    handleOpenDlt();
    deleteVendor();
    handleCloseDltConfirmation();
  };

  //view vendor click
  const viewVendorClick = (unique_id, rowData) => {
    setVendorMain(false);
    setOpenViewVendor(true);
    let idCred = rowData?.token;
    getIndividualData(idCred, "vendor_token");
    let uniqueLocalData = getUniqueData(vendorsData, "token", rowData?.token);
    setUniqueLocalData(uniqueLocalData);
  };
  const [v_token, setv_token] = useState();
  const editVendorClick = (unique_user_id, rowData) => {
    setVendorsAction({
      addVendor: false,
      updateVendor: true,
      addBulkItems: false,
    });
    setVendorMain(true);
    setOpen(true);
    setUniqueDataID(rowData?.token);
    setv_token(rowData?.token);
    let updateidCred = rowData?.token;
    getIndividualData(updateidCred, "vendor_token");
    const updatedRowData = getUniqueData(vendorsData, "token", rowData?.token);
    updateInputs(updatedRowData);

    setUniqueLocalData(unique_user_id);
  };

  // modal states
  const [open, setOpen] = useState(false);

  const [primaryBtnLabel, setPrimaryBtnLabel] = useState();
  const [vendorsAction, setVendorsAction] = useState({
    addVendor: false,
    updateVendor: false,
    addBulkItems: false,
  });
  useEffect(() => {
    setPrimaryBtnLabel(
      vendorsAction.addVendor
        ? "Add"
        : vendorsAction.updateVendor
        ? "Update"
        : vendorsAction.addBulkItems
        ? "Add Bulk Vendors"
        : ""
    );
  }, [vendorsAction]);

  const updateInputs = (data) => {
    if (
      data?.vendor_code == null ||
      data?.vendor_code == undefined ||
      data?.vendor_code == ""
    ) {
      setiseditable(true);
    } else if (data?.vendor_code.length > 0) {
      setiseditable(false);
    }

    setPersonName((prev) => ({
      ...prev,
      value: data?.full_name || "",
    }));

    setCompanyName((prev) => ({
      ...prev,
      value: data?.company_name || "",
    }));

    setVendorCode((prev) => ({
      ...prev,
      value: data?.vendor_code || "",
    }));

    setVendorRegisteredEmail((prev) => ({
      ...prev,
      value: data?.official_email_address || "",
    }));
  };

  // ==== OPEN "Add Vendor" guarded by limit ====
  const handleOpen = () => {
    if (guardLimitAndShow()) return; // STOP if limit reached
    setOpen(true);
    setVendorsAction({
      addVendor: true,
      updateVendor: false,
      addBulkItems: false,
    });
  };

  const handleClose = () => {
    setOpen(false);
    resetForm();
  };

  //popup flags
  const [openS, setOpenS] = useState(false);
  const handleOpenS = () => setOpenS(true);
  const handleCloseS = () => {
    setOpenS(false);
    resetForm();
  };

  const [CompanyName, setCompanyName] = useState({
    value: "",
    errorMsg: "",
    isValid: true,
  });
  const [companyList, setCompanyList] = useState([]);
  const [VendorRegisteredEmail, setVendorRegisteredEmail] = useState({
    value: "",
    errorMsg: "",
    isValid: true,
  });
  const [PersonName, setPersonName] = useState({
    value: "",
    errorMsg: "",
    isValid: true,
  });
  const [VendorCode, setVendorCode] = useState({
    value: "",
    errorMsg: "",
    isValid: true,
  });
  const [csvFile, setCsvFile] = useState({
    value: "",
    isValid: true,
  });
  const resetForm = () => {
    setVendorRegisteredEmail({
      value: "",
      isValid: true,
    });
    setCompanyName({
      value: "",
      isValid: true,
    });
    setPersonName({
      value: "",
      isValid: true,
    });
    setCsvFile({
      value: "",
      isValid: true,
    });
    setVendorCode({
      value: "",
      isValid: true,
    });
    setPrimaryBtnError({
      error: false,
      errorMsg: "",
    });
  };

  const regexForAlphabets = /[^a-zA-Z\s]/g;
  const regexForAlphaNumeric = /[^a-zA-Z0-9\s]+/g;
  const regexForNumber = /[^\d\s]/g;

  const validateForm = (query) => {
    const isEmailValid = validateEmail(VendorRegisteredEmail.value);
    const isCompanyName = emptyCheck(CompanyName.value);
    const isPersonName = emptyCheck(PersonName.value);

    const isCsvFile = validateFile(
      csvFile.value,
      false,
      ["csv", "xlsx"],
      5
    ).isValid;

    setVendorRegisteredEmail((prev) => ({
      ...prev,
      isValid: isEmailValid,
    }));
    setCompanyName((prev) => ({ ...prev, isValid: isCompanyName }));
    setPersonName((prev) => ({ ...prev, isValid: isPersonName }));

    setCsvFile((prev) => ({
      ...prev,
      isValid: isCsvFile,
    }));

    if (query === "bulkData") {
      setCsvFile((prev) => ({
        ...prev,
        isValid: isCsvFile,
      }));
      return isCsvFile;
    } else {
      return isEmailValid && isCompanyName && isPersonName;
    }
  };

  let abortController = new AbortController();

  const getCompanyList = async (searchValue) => {
    try {
      abortController.abort();

      const newAbortController = new AbortController();
      abortController = newAbortController;

      const formData = new FormData();
      formData.append("buyer_token", org_token);
      formData.append("search", searchValue);

      const response = await axios({
        method: "POST",
        url: `${API_ENDPOINT.getCompanyList}`,
        data: formData,
        headers: {
          Authorization: `Bearer ${auth_token}`,
        },
        signal: abortController.signal,
      });

      let responseData = response?.data?.response;
      setCompanyList(responseData?.map((e) => e?.company_name));
    } catch (error) {
      if (error.name === "AbortError") {
        console.log("Request aborted:", error.message);
      } else {
        console.log(error);
      }
    }
  };

  const addVendor = async () => {
    await axios({
      method: "POST",
      url: `${API_ENDPOINT.add_vendor}`,
      data: {
        company_name: CompanyName.value,
        person_name: PersonName.value,
        company_official_email: VendorRegisteredEmail.value,
        buyer_token: org_token,
      },
      headers: {
        Authorization: `Bearer ${auth_token}`,
      },
    })
      .then((res) => {
        setPopupHeroText(res?.data?.response);
        setPopupMessage(
          res?.data?.response.includes("invite")
            ? "Looks like the vendor doesn't exist, so we sent an invite mail to onboard them."
            : "Vendor has been added successfully!"
        );
        setPopupImage(successPopupImg);
        handleOpenS();
        handleClose();
        resetForm();
        setLoadingState(false);
        GetAllData();
        setPrimaryBtnError({
          error: false,
          errorMsg: "",
        });
      })
      .catch((err) => {
        console.log(err);
        setLoadingState(false);
        setPrimaryBtnError({
          error: true,
          errorMsg: Object.values(err?.response?.data)[0],
        });
      });
  };

  const updateVendor = async () => {
    const formData = new FormData();

    CompanyName.value && formData.append("company_name", CompanyName.value);
    PersonName.value && formData.append("person_name", PersonName.value);
    VendorRegisteredEmail.value &&
      formData.append("company_official_email", VendorRegisteredEmail.value);
    VendorCode.value && formData.append("vendor_code", VendorCode.value);

    axios({
      url: `${API_ENDPOINT.update_vendor}${uniqueDataID}`,
      method: "POST",
      data: {
        vendor_token: uniqueDataID,
        company_name: CompanyName.value,
        first_name: PersonName.value,
        company_official_email: VendorRegisteredEmail.value,
        buyer_token: org_token,
        vendor_code: VendorCode.value,
      },
      headers: {
        Authorization: `Bearer ${auth_token}`,
      },
    })
      .then((res) => {
        setLoadingState(false);
        GetAllData();
        setPopupHeroText("Vendor Updated!");
        setPopupMessage(res?.data?.response);
        setPopupImage(successPopupImg);
        handleOpenS();
        handleClose();
        resetForm();
      })
      .catch((err) => {
        console.log(err);
        setLoadingState(false);
        setPrimaryBtnError({
          error: true,
          errorMsg: Object.values(err?.response?.data)[0],
        });
      });
  };

  // ADD Bulk Items function
  const addBulkItems = async () => {
    setLoadingState(true);
    const formData = new FormData();

    formData.append("org_token", org_token);
    formData.append("csv_file", csvFile.value);

    await axios({
      url: `${API_ENDPOINT.vendor_csv_upload}`,
      method: "POST",
      data: formData,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${auth_token}`,
      },
    })
      .then((res) => {
        setLoadingState(false);
        GetAllData();
        setPopupHeroText("Vendors Added!");
        setPopupMessage(res?.data?.response);
        setPopupImage(successPopupImg);
        handleOpenS();
        handleClose();
        resetForm();
        setLoadingState(false);
      })
      .catch((err) => {
        setLoadingState(false);
        setPrimaryBtnError({
          error: true,
          errorMsg:
            (typeof err?.response?.data?.response !== "object" &&
              err?.response?.data?.response) ||
            "Something went wrong! please check the file values & try again.",
        });
        setLoadingState(false);
      });
  };

  // submit click (guarded for limit)
  const handleSubmit = async () => {
    const validation = vendorsAction.addBulkItems
      ? validateForm("bulkData")
      : validateForm();

    if (validation) {
      if (vendorsAction.addVendor) {
        setLoadingState(true);
        if (guardLimitAndShow()) {
          setLoadingState(false);
          return;
        }
        addVendor();
      } else if (vendorsAction.updateVendor) {
        setLoadingState(true);
        updateVendor();
      } else if (vendorsAction.addBulkItems) {
        setLoadingState(true);
        if (guardLimitAndShow()) {
          setLoadingState(false);
          return;
        }
        addBulkItems();
      }
    } else {
      setPrimaryBtnError({
        error: true,
        errorMsg: "Please fill out all fields",
      });

      setPersonName((prevState) => ({
        ...prevState,
        isValid: prevState.isValid,
      }));
      setCompanyName((prevState) => ({
        ...prevState,
        isValid: prevState.isValid,
      }));
      setVendorCode((prevState) => ({
        ...prevState,
        isValid: prevState.isValid,
      }));
      setVendorRegisteredEmail((prevState) => ({
        ...prevState,
        isValid: prevState.isValid,
      }));
    }
  };

  // Invite vendor Inputs
  const vendorsTabHeading = (
    <HeaderTitle
      titleText={
        vendorsAction.addVendor
          ? "Add Vendors"
          : vendorsAction.updateVendor
          ? "Update Vendors"
          : vendorsAction.addBulkItems
          ? "Upload Bulk Vendors"
          : ""
      }
      customclass={classes.popupHeading}
    />
  );

  const vendorsTabInputs = [
    (vendorsAction.addVendor || vendorsAction.updateVendor) && (
      <DFreeSoloInput
        label="Company Name"
        value={CompanyName.value}
        options={companyList}
        onChange={(value) => {
          setCompanyName({
            value: value,
            isValid: emptyCheck(value),
          });
          if (value?.length > 2) {
            getCompanyList(value);
          } else {
            setCompanyList([]);
          }
        }}
        error={!CompanyName.isValid}
        errorMsg={"Company name is required"}
        size={"100%"}
      />
    ),

    (vendorsAction.addVendor || vendorsAction.updateVendor) && (
      <div className={classes.fields}>
        <DTextInput
          label="Person Name"
          maxLength={250}
          type="text"
          value={PersonName.value}
          onChange={(e) => {
            let val = e?.target?.value?.replace(regexForAlphabets, "");
            setPersonName({
              value: val,
              isValid: emptyCheck(e?.target?.value),
            });
          }}
          error={!PersonName.isValid}
          errorMsg={"Person name is required"}
          size={"24rem"}
          customClassName={classes.addVendorPopupInput}
        />

        <DTextInput
          label={"Email"}
          value={VendorRegisteredEmail.value}
          onChange={(e) => {
            let val = e.target.value;
            setVendorRegisteredEmail({
              value: val,
              isValid: validateEmail(val),
            });
          }}
          error={!VendorRegisteredEmail.isValid}
          errorMsg={
            !emptyCheck(VendorRegisteredEmail.value)
              ? "Email is required"
              : !VendorRegisteredEmail.isValid
              ? "Invalid email format"
              : ""
          }
          customClassName={classes.addVendorPopupInput}
          size={"24rem"}
        />
      </div>
    ),

    vendorsAction.addBulkItems && (
      <div className={classes.input_container}>
        <DefaultLabel label={"Upload CSV file"} />
        <DFileUpload
          fileTypes={".xlsx,.csv"}
          customFileTypeText={"(Supported format CSV)"}
          onFileUpload={(file) => {
            let isValidFile = validateFile(
              file,
              false,
              ["csv", "xlsx"],
              5
            ).isValid;
            setCsvFile({
              value: file,
              isValid: isValidFile,
            });
          }}
          error={!csvFile.isValid}
          errorMsg={
            validateFile(csvFile.value, false, ["csv", "xlsx"], 5, "CSV file")
              .errorMessage
          }
          size={"100%"}
        />
        <p
          className={classes.linkBtn}
          onClick={() => {
            saveAs(sampleCSV, "Sample CSV");
          }}
        >
          Sample CSV
        </p>
      </div>
    ),
  ];

  const popupActions = [
    <DButtonOutlined
      key="cancel"
      label={"Cancel"}
      onClick={handleClose}
      btnWidth={"17rem"}
      btnHeight={"4rem"}
      buyerBtn={true}
    />,
    <DButton
      key="submit"
      label={primaryBtnLabel}
      loadingState={loadingState}
      btnWidth={"17rem"}
      btnHeight={"4rem"}
      buyerBtn={true}
      error={primaryBtnError.error}
      errorMsg={primaryBtnError.errorMsg}
      onClick={handleSubmit}
    />,
  ];

  //bulk vendors (guarded)
  const handleOpenAddBulkItem = () => {
    if (guardLimitAndShow()) return; // STOP if limit reached
    setOpen(true);
    resetForm();
    setVendorsAction({
      addVendor: false,
      updateVendor: false,
      addBulkItems: true,
    });
  };

  // data for view vendor list
  const business_info = [
    {
      label: "Company Name",
      value: uniqueData?.company_name || "-",
    },
    {
      label: "Company Type",
      value: uniqueData?.company_type || "-",
    },
    {
      label: "Company Website",
      value: uniqueData?.company_website || "-",
    },
    {
      label: "Company Identification Number",
      value: uniqueData?.company_registration_number || "-",
    },
  ];

  const address = [
    {
      label: "Address",
      value: uniqueData?.company_address || "-",
    },
    {
      label: "Working Days",
      value: uniqueData?.working_days || "-",
    },
    {
      label: "Working Hours",
      value: uniqueData?.working_hours || "-",
    },
  ];

  const contact_info = [
    {
      label: "Phone Number",
      value: uniqueData?.company_phone_number || "-",
    },
    {
      label: "Fax Number",
      value: uniqueData?.company_fax_number || "-",
    },
    {
      label: "Official Email",
      value: uniqueData?.company_official_email || "-",
    },
  ];

  //tab 2
  const bank_details = [
    {
      label: "Bank Name",
      value: uniqueData?.bank_name || "-",
    },
    {
      label: "Account Holder Name",
      value: uniqueData?.account_holder_name || "-",
    },
    {
      label: "Account Number",
      value: uniqueData?.account_number || "-",
    },
    {
      label: "Account Type",
      value: uniqueData?.account_type || "-",
    },
    {
      label: "Branch Code",
      value: uniqueData?.branch_code || "-",
    },
    {
      label: "IFSC/SWIFT/IBAN Code",
      value: uniqueData?.bank_identification_code || "-",
    },
    {
      label: "Branch Address",
      value: uniqueData?.branch_address || "-",
    },
  ];

  const statutory_details = [
    {
      label: "PAN Number",
      value: uniqueData?.pan_number || "-",
    },
    {
      label: "Tax ID Type",
      value: uniqueData?.tax_id_types || "-",
    },
    {
      label: "Tax Code",
      value: uniqueData?.tax_identification_number || "-",
    },
    {
      label: "LUT Number",
      value: uniqueData?.lut_number || "-",
    },
    {
      label: "LUT Date",
      value: uniqueData?.lut_date || "-",
    },
    {
      label: "ISO Certification Number",
      value: uniqueData?.iso_number || "-",
    },
    {
      label: "MSME Register Number",
      value: uniqueData?.msme_registration_number || "-",
    },
  ];

  //tab 3
  const proprietor_CD = [
    {
      label: "First Name",
      value: uniqueData?.first_name || "-",
    },
    {
      label: "Last Name ",
      value: uniqueData?.last_name || "-",
    },
    {
      label: "Designation",
      value: uniqueData?.designation || "-",
    },
    {
      label: "Official Mobile Number",
      value: uniqueData?.official_mobile_number || "-",
    },
    {
      label: "Official Email Address",
      value: uniqueData?.official_email_address || "-",
    },
  ];

  const rep_CD = [
    {
      label: "First Name",
      value: uniqueData?.rep_first_name || "-",
    },
    {
      label: "Last Name ",
      value: uniqueData?.rep_last_name || "-",
    },
    {
      label: "Designation",
      value: uniqueData?.rep_designation || "-",
    },
    {
      label: "Official Mobile Number",
      value: uniqueData?.rep_official_mobile_number || "-",
    },
    {
      label: "Official Email Address",
      value: uniqueData?.rep_official_email_address || "-",
    },
  ];

  const finance_rep_CD = [
    {
      label: "First Name",
      value: uniqueData?.financerep_first_name || "-",
    },
    {
      label: "Last Name ",
      value: uniqueData?.financerep_last_name || "-",
    },
    {
      label: "Designation",
      value: uniqueData?.financerep_designation || "-",
    },
    {
      label: "Official Mobile Number",
      value: uniqueData?.financerep_mobile_num || "-",
    },
    {
      label: "Official Email Address",
      value: uniqueData?.financerep_email || "-",
    },
  ];

  //tab 4

  const documents = [
    {
      label: "Business Registration Certificate",
      value: uniqueData?.business_reg_certificate,
    },
    { label: "PAN Card", value: uniqueData?.pan_card },
    {
      label: "One Cancelled Cheque Leaf",
      value: uniqueData?.one_cancelled_cheque_leaf,
    },
    {
      label: "GST Certificate",
      value: uniqueData?.tax_registration_certificate,
    },
    { label: "MSME Certificate", value: uniqueData?.msme_certificate },
    { label: "TDS Certificate", value: uniqueData?.tds_certificate },
    {
      label: "CIN Certificate",
      value: uniqueData?.corporate_identity_certificate,
    },
  ];

  // Tab5
  const gstDetails = [
    {
      label: "GST Number",
      value: uniqueData?.tax_identification_number || "-",
    },
    { label: "Trade Name", value: uniqueData?.gst_trade_name || "-" },
    { label: "Legal Name", value: uniqueData?.pan_name || "-" },
    {
      label: "Constitution of Business",
      value: uniqueData?.gst_place_of_business || "-",
    },
    {
      label: "Nature of Business",
      value: uniqueData?.gst_nature_of_business || "-",
    },
    {
      label: "Date of Liability",
      value: uniqueData?.gst_date_of_liability || "-",
    },
    {
      label: "Date of Validity",
      value: uniqueData?.gst_date_of_validity || "-",
    },
    {
      label: "Type of Registration",
      value: uniqueData?.gst_type_of_registration || "-",
    },
  ];
  // tab 6
  const panDetails = [
    { label: "PAN Number", value: uniqueData?.pan_number || "-" },
    { label: "PAN Name", value: uniqueData?.pan_name || "-" },
  ];

  // tab7
  const msmeDetails = [
    {
      label: "MSME Register Number",
      value: uniqueData?.msme_registration_number || "-",
    },
    {
      label: "Name of enterprise",
      value: uniqueData?.msme_name_of_enterprise || "-",
    },
    {
      label: "Type of enterprise",
      value: uniqueData?.msme_registration_number || "-",
    },
    { label: "Major Activity", value: uniqueData?.msme_major_activity || "-" },
    { label: "Date of Filing", value: uniqueData?.msme_date_of_filing || "-" },
  ];

  // details tab object
  const TabDetails = [
    {
      tabName: "GST Details",
      currentTab: tab5,
      clickFn: tab5Click,
    },
    {
      tabName: "PAN Details",
      currentTab: tab6,
      clickFn: tab6Click,
    },
    {
      tabName: "Business Info",
      currentTab: tab1,
      clickFn: tab1Click,
    },
    {
      tabName: "MSME Details",
      currentTab: tab7,
      clickFn: tab7Click,
    },
    {
      tabName: "Bank Details",
      currentTab: tab2,
      clickFn: tab2Click,
    },
    {
      tabName: "Contact Details",
      currentTab: tab3,
      clickFn: tab3Click,
    },
    {
      tabName: "Documents",
      currentTab: tab4,
      clickFn: tab4Click,
    },
    {
      tabName: "Item Mapping",
      currentTab: tab8,
      clickFn: tab8Click,
    },
  ];
  const TabDetailsVendorContact = [
    {
      tabName: "Basic Details",
      currentTab: tab1,
    },
  ];

  const toggleDocument = (docUrl) => {
    setSelectedDocs((prev) =>
      prev.includes(docUrl)
        ? prev.filter((d) => d !== docUrl)
        : [...prev, docUrl]
    );
  };

  const handleDownloadSelectedDocs = async () => {
    if (!selectedDocs || selectedDocs.length === 0) return;

    try {
      const zip = new JSZip();

      // Optional: you can show loading here using loadingStateDwnload, if you want
      setLoadingStateDwnload(true);

      for (let i = 0; i < selectedDocs.length; i++) {
        const fileUrl = selectedDocs[i];
        if (!fileUrl) continue;

        const fileName = fileUrl.split("/").pop() || `file_${i + 1}`;

        const response = await fetch(fileUrl);
        if (!response.ok) {
          console.error(`Failed to fetch ${fileUrl}`);
          continue;
        }

        const blob = await response.blob();
        zip.file(fileName, blob);
      }

      const zipBlob = await zip.generateAsync({ type: "blob" });
      saveAs(zipBlob, "Vendor_Documents.zip");
      clearSelectedDocs();
    } catch (error) {
      console.error("Zip download error:", error);
      setPopupHeroText("Unable to Download");
      setPopupMessage(
        "Something went wrong while downloading the selected documents. Please try again."
      );
      setPopupImage(deletePopupImg);
      setOpenS(true);
    } finally {
      setLoadingStateDwnload(false);
    }
  };

  const clearSelectedDocs = () => {
    setSelectedDocs([]);
  };

  const getMismatchReason = (vendor) => {
    const issues = [];

    if (vendor?.pan_status !== "Verified") issues.push("PAN not verified");
    if (vendor?.gst_status !== "Verified") issues.push("GST not verified");
    if (vendor?.bank_status !== "Verified") issues.push("Cheque not verified");

    if (vendor?.cin_status === "Mismatch") issues.push("CIN mismatch");
    if (vendor?.msme_status === "Mismatch") issues.push("MSME mismatch");

    return issues.length > 0 ? issues.join(", ") : "Unknown reason";
  };

  useEffect(() => {
    const chatActionRaw = sessionStorage.getItem("CHAT_ACTION");
    if (!chatActionRaw) return;

    const { action, vendor_Master_search } = JSON.parse(chatActionRaw);

    console.log("CHAT ACTION:", action);
    console.log("VENDOR SEARCH VALUE:", vendor_Master_search);

    // EXPORT
    if (action === "export_vendor_master") {
      downloadFile({
        key: "org_token",
        value: Datas?.organization_token,
        fileNameProp: "Vendors Data",
        outputFormat: "CSV",
        API_ENDPOINT: API_ENDPOINT.csv_buyer_vendor_list,
        authToken: auth_token,
        setLoadingState: setLoadingStateDwnload,
      });

      sessionStorage.removeItem("CHAT_ACTION");
      return;
    }

    // 🔍 SEARCH VENDOR
    if (action === "search_vendor_details") {
      if (!vendorsData || vendorsData.length === 0) return;

      console.log("INSIDE SEARCH BLOCK:", vendor_Master_search);

      setSearchQuery(vendor_Master_search || "");
      setPageNumber(1);

      sessionStorage.removeItem("CHAT_ACTION");
    }
  }, [vendorsData]);

  return (
    <div className={classes.users_tab_wrapper}>
      <div className={classes.users_topHeader}>
        <div className={`${classes.lhs} flex`}>
          {vendorMain ? (
            <HeaderTitle
              titleText="Vendor Master"
              customclass={classes.dashHead}
            />
          ) : (
            <div
              className={classes.flex}
              style={{ cursor: "pointer" }}
              onClick={() => {
                setVendorMain(true);
                setOpenViewVendor(false);
                tab1Click();
              }}
            >
              <ArrowLeft sx={{ fontSize: "30px" }} />{" "}
              <HeaderTitle
                titleText={uniqueLocalData?.company_name}
                customclass={classes.dashHead}
              />
            </div>
          )}
        </div>
      </div>

      {vendorMain && (
        <>
          <div className={classes.search_add_wrapper}>
            <SearchBar
              value={searchQuery}
              onChange={(query) => {
                setSearchQuery(query);
                localStorage.setItem("vendor_search_query", query);
                setPageNumber(1);
              }}
            />

            <div className={classes.flex}>
              <DropdownBtnOutlined
                label="DOWNLOAD AS"
                btnHeight="4rem"
                btnWidth="18rem"
                loadingState={loadingStateDwnload}
                disabled={vendorsData?.length === 0}
                onClick={(fileFormat) => {
                  downloadFile({
                    key: "org_token",
                    value: Datas?.organization_token,
                    fileNameProp: "Vendors Data",
                    outputFormat: fileFormat,
                    API_ENDPOINT: API_ENDPOINT.csv_buyer_vendor_list,
                    authToken: auth_token,
                    setLoadingState: setLoadingStateDwnload,
                  });
                }}
                options={["CSV", "PDF"]}
              />

              <Dbutton
                iconWidth="1rem"
                iconHeight="1rem"
                label="UPLOAD"
                btnHeight="4rem"
                buyerBtn={true}
                onClick={handleOpenAddBulkItem}
              />

              <DButton
                labelImg={plusIcon}
                iconHeight={"15px"}
                iconwidth={"15px"}
                label="ADD VENDOR"
                btnHeight="4rem"
                buyerBtn={true}
                onClick={handleOpen}
              />
            </div>
          </div>

          <div className={`${classes.d_dataTable}`}>
            {/* <DataTable
              headings={ headings }
              tableData={
                vendorsData?.map((row) => ({
                  ...row,
                  onboarding_status: getOnboardingStatus(row),
                  reverify_action: getOnboardingStatus(row) === "Partially Onboarded" ? "reverify" : "-",
                }))
              }
              actions={ true }
              tableSize={ vendorsData?.length === 0 ? "100%" : "100vw" }
              viewBtn={ true }
              viewClick={ viewVendorClick }
              editBtn={ false }
              editClick={ editVendorClick }
              deleteBtn={ true }
              deleteClick={ handleOpenDltConfirmation }
              errorMessage={ tableProps.errorMessage }
              isLoading={ tableProps.isLoading }
              sorting={ true }
              setSortingColumnName={ setSortingColumnName }
              sortingColumnName={ sortingColumnName }
              setSortingOrder={ setSortingOrder }
              sortingOrder={ sortingOrder }
              customCellRender={ {
                reverify_action: (value, row) =>
                  value === "reverify" ? (
                    <Button
                      variant="contained"
                      size="small"
                      style={ {
                        padding: "6px 16px",
                        background: "#0066ff",
                        color: "white",
                        borderRadius: "6px",
                        border: "none",
                        cursor: "pointer",
                        fontSize: "0.875rem",
                        fontWeight: "500",
                        textTransform: "none",
                        minWidth: "90px",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",

                      } }
                      onClick={ (e) => {
                        e.stopPropagation();
                        reverifyVendor(row.token);
                      } }
                    >
                      Reverify
                    </Button>
                  ) : (
                    <span style={ { color: "#999", fontSize: "0.875rem" } }>Verified</span>
                  )
              } }
            /> */}

            <DataTable
              headings={headings}
              tableData={vendorsData?.map((row) => ({
                ...row,
                onboarding_status: getOnboardingStatus(row),
                reverify_action:
                  getOnboardingStatus(row) === "Partially Onboarded" ? (
                    <Tooltip
                      title={getMismatchReason(row)}
                      placement="bottom"
                      slotProps={{
                        tooltip: {
                          sx: {
                            fontSize: "1.1rem",
                            padding: "10px 12px",
                            maxWidth: 300,
                            backgroundColor: "#333",
                            color: "#fff",
                            borderRadius: "8px",
                          },
                        },
                      }}
                    >
                      <Button
                        variant="contained"
                        size="small"
                        style={{
                          padding: "6px 16px",
                          background: "#0066ffe3",
                          color: "white",
                          borderRadius: "6px",
                          border: "none",
                          cursor: "pointer",
                          fontSize: "1.2rem",
                          fontWeight: "500",
                          textTransform: "none",
                          minWidth: "90px",
                          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          reverifyVendor(row.official_email_address);
                        }}
                      >
                        Reverify
                      </Button>
                    </Tooltip>
                  ) : (
                    <span style={{ color: "#999", fontSize: "1.2rem" }}>-</span>
                  ),
              }))}
              actions={true}
              tableSize={vendorsData?.length === 0 ? "100%" : "100vw"}
              viewBtn={true}
              viewClick={viewVendorClick}
              editBtn={false}
              editClick={editVendorClick}
              deleteBtn={true}
              deleteClick={handleOpenDltConfirmation}
              errorMessage={tableProps.errorMessage}
              isLoading={tableProps.isLoading}
              sorting={true}
              setSortingColumnName={setSortingColumnName}
              sortingColumnName={sortingColumnName}
              setSortingOrder={setSortingOrder}
              sortingOrder={sortingOrder}
            />

            <PaginationComponent
              pageNumber={pageNumber}
              currentPage={currentPage || 0}
              itemsPerPage={itemsPerPage || 0}
              totalItems={totalItems || 0}
              setPageNumber={setPageNumber}
              previouPageClick={() => {
                previouPageClick(pageNumber, setPageNumber);
              }}
              nextPageClick={() => {
                nextPageClick(pageNumber, setPageNumber, paginationData);
              }}
              disablePrevious={parseInt(pageNumber) === 1 || pageNumber === ""}
              disableNext={
                parseInt(pageNumber) === paginationData?.page_count ||
                !paginationData ||
                pageNumber === ""
              }
            />
          </div>
        </>
      )}

      {openViewVendor && (
        <>
          <div className={classes.ViewVendorHeader}>
            {TabDetails.map((tab, index) => (
              <DetailsTab
                key={index}
                large={true}
                tabName={tab.tabName}
                currentTab={tab.currentTab}
                clickFn={tab.clickFn}
              />
            ))}
          </div>

          {tab1 && (
            <div className={classes.tabsScreens}>
              <div className={classes.infoSection}>
                <HeaderTitle
                  customclass={classes.tabHeading}
                  titleText={"Business Info"}
                />

                <div className={classes.info}>
                  {business_info.map((e, i) => {
                    return (
                      <InfoLabel
                        isLoading={loadingState}
                        key={i}
                        label={e.label}
                        value={e.value}
                        size={"22rem"}
                      />
                    );
                  })}
                </div>
              </div>
              <>
                <div className={classes.infoSection}>
                  <HeaderTitle
                    customclass={classes.tabHeading}
                    titleText={"Address"}
                  />

                  <div className={classes.info}>
                    {address.map((e, i) => {
                      return (
                        <InfoLabel
                          isLoading={loadingState}
                          key={i}
                          label={e.label}
                          value={e.value}
                          size={"22rem"}
                        />
                      );
                    })}
                  </div>
                </div>

                <div className={classes.infoSection}>
                  <HeaderTitle
                    customclass={classes.tabHeading}
                    titleText={"Contact Info"}
                  />

                  <div className={classes.info}>
                    {contact_info.map((e, i) => {
                      return (
                        <InfoLabel
                          isLoading={loadingState}
                          key={i}
                          label={e.label}
                          value={e.value}
                          size={"22rem"}
                        />
                      );
                    })}
                  </div>
                </div>
              </>
            </div>
          )}

          {tab2 && (
            <div className={classes.tabsScreens}>
              <div className={classes.infoSection}>
                <HeaderTitle
                  customclass={classes.tabHeading}
                  titleText={"Bank Details"}
                />

                <div className={classes.info}>
                  {bank_details.map((e, i) => (
                    <InfoLabel
                      isLoading={loadingState}
                      key={i}
                      label={e.label}
                      value={e.value}
                      size={"22rem"}
                    />
                  ))}
                </div>
              </div>

              <div className={classes.infoSection}>
                <HeaderTitle
                  customclass={classes.tabHeading}
                  titleText={"Statutory Details"}
                />

                <div className={classes.info}>
                  {statutory_details.map((e, i) => (
                    <InfoLabel
                      isLoading={loadingState}
                      key={i}
                      label={e.label}
                      value={e.value}
                      size={"22rem"}
                    />
                  ))}
                </div>
              </div>
            </div>
          )}

          {tab3 && (
            <div className={classes.tabsScreens}>
              <div className={classes.infoSection}>
                <HeaderTitle
                  customclass={classes.tabHeading}
                  titleText={"Proprietor Contact Details"}
                />
                <div className={classes.info}>
                  {proprietor_CD.map((e, i) => (
                    <InfoLabel
                      isLoading={loadingState}
                      key={i}
                      label={e.label}
                      value={e.value}
                      size={"22rem"}
                    />
                  ))}
                </div>
              </div>

              <div className={classes.infoSection}>
                <HeaderTitle
                  customclass={classes.tabHeading}
                  titleText={"Representative Contact Details"}
                />

                <div className={classes.info}>
                  {rep_CD.map((e, i) => (
                    <InfoLabel
                      isLoading={loadingState}
                      key={i}
                      label={e.label}
                      value={e.value}
                      size={"22rem"}
                    />
                  ))}
                </div>
              </div>

              <div className={classes.infoSection}>
                <HeaderTitle
                  customclass={classes.tabHeading}
                  titleText={"Finance Representative Contact Details"}
                />

                <div className={classes.info}>
                  {finance_rep_CD.map((e, i) => (
                    <InfoLabel
                      isLoading={loadingState}
                      key={i}
                      label={e.label}
                      value={e.value}
                      size={"22rem"}
                    />
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* {tab4 && (
            <div className={classes.tabsScreens}>
              <div className={classes.infoSection}>
                <HeaderTitle
                  customclass={classes.tabHeading}
                  titleText={"Business Info"}
                />

                <div className={`${classes.infoImageFrame} ${classes.fStart}`}>
                  {documents.map((e, i) => (
                    <ImageView
                      key={i}
                      imgSrc={`${e?.value || noImageAvailable}`}
                      label={e.label}
                    />
                  ))}
                </div>
              </div>
            </div>
          )} */}

          {tab4 && (
            <div className={classes.tabsScreens}>
              <div className={classes.infoSection}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <HeaderTitle
                    customclass={classes.tabHeading}
                    titleText={"Vendor Documents"}
                  />
                  {/* DOWNLOAD SELECTED BUTTON */}
                  <div
                    style={{
                      marginBottom: "1rem",
                      display: "flex",
                      gap: "1rem",
                      alignItems: "center",
                      justifyContent: "end",
                    }}
                  >
                    {selectedDocs.length > 0 && (
                      <DButtonOutlined
                        label="Clear Selection"
                        btnHeight="3.5rem"
                        buyerBtnOutline={true}
                        onClick={clearSelectedDocs}
                      />
                    )}

                    <DButton
                      label="Download Selected"
                      btnHeight="3.5rem"
                      buyerBtn={true}
                      disabled={selectedDocs.length === 0}
                      onClick={handleDownloadSelectedDocs}
                    />
                  </div>
                </div>

                <div className={`${classes.infoImageFrame} ${classes.fStart}`}>
                  {documents.map((doc, i) => (
                    <div
                      key={i}
                      style={{ width: "18rem", marginRight: "2rem" }}
                    >
                      {/* checkbox */}
                      <label
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "0.5rem",
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={selectedDocs.includes(doc.value)}
                          onChange={() => toggleDocument(doc.value)}
                        />
                        {/* <span>{doc.label}</span> */}
                      </label>

                      {/* Image preview */}
                      <ImageView
                        imgSrc={doc.value || noImageAvailable}
                        label={doc.label}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {tab5 && (
            <div className={classes.tabsScreens}>
              <div className={classes.infoSection}>
                <HeaderTitle
                  customclass={classes.tabHeading}
                  titleText={"GST Details"}
                />
                <div className={classes.info}>
                  {gstDetails.map((e, i) => (
                    <InfoLabel
                      isLoading={loadingState}
                      key={i}
                      label={e.label}
                      value={e.value}
                      size={"22rem"}
                    />
                  ))}
                </div>
              </div>
            </div>
          )}

          {tab6 && (
            <div className={classes.tabsScreens}>
              <div className={classes.infoSection}>
                <HeaderTitle
                  customclass={classes.tabHeading}
                  titleText={"PAN Details"}
                />
                <div className={classes.info}>
                  {panDetails.map((e, i) => (
                    <InfoLabel
                      isLoading={loadingState}
                      key={i}
                      label={e.label}
                      value={e.value}
                      size={"22rem"}
                    />
                  ))}
                </div>
              </div>
            </div>
          )}

          {tab7 && (
            <div className={classes.tabsScreens}>
              <div className={classes.infoSection}>
                <HeaderTitle
                  customclass={classes.tabHeading}
                  titleText={"MSME Details"}
                />
                <div className={classes.info}>
                  {msmeDetails.map((e, i) => (
                    <InfoLabel
                      isLoading={loadingState}
                      key={i}
                      label={e.label}
                      value={e.value}
                      size={"22rem"}
                    />
                  ))}
                </div>
              </div>
            </div>
          )}

          {tab8 && (
            <div className={classes.tabsScreens}>
              <div className={classes.infoSection}>
                <HeaderTitle
                  customclass={classes.tabHeading}
                  titleText={"Item Mapping"}
                />

                <VendorItemMapping
                  org_token={organization_token}
                  user_token={org_token}
                  auth_token={auth_token}
                  dispatch={dispatch}
                  vendorToken={vendorUserToken}
                />
              </div>
            </div>
          )}
        </>
      )}

      {/* modal popups */}

      {/* add/upload vendor modal */}
      <Modal
        open={open}
        closeAfterTransition
        slotProps={{
          backdrop: {
            TransitionComponent: Fade,
          },
        }}
        sx={{
          overflow: "auto",
        }}
      >
        <Fade in={open}>
          <div
            className={classes.flex}
            style={{
              height: "100vh",
            }}
          >
            <PopupFrame
              customClass={classes.InviteVendorPopup}
              styleCenterDiv={classes.centerDiv}
              inputChildren={vendorsTabInputs}
              poupHeading={vendorsTabHeading}
              actionButtons={popupActions}
              closePopup={handleClose}
            />
          </div>
        </Fade>
      </Modal>

      {/* success / alert modal popup */}
      <Modal open={openS}>
        <Fade in={openS}>
          <Box>
            <SuccessPopupDashboard
              popupImage={popupImage}
              popupHeroText={popupHeroText}
              popupDescription={popupMessage}
              popBtn={true}
              buyerBtn={true}
              buyerBtnOutline={true}
              btnText={"Okay"}
              btnClick={handleCloseS}
            />
          </Box>
        </Fade>
      </Modal>

      {/* delete error modal two states - confirmation and deletion */}

      {/* confirmation */}
      <Modal open={openDltConfirmation}>
        <Box>
          <SuccessPopupDashboard
            popupImage={deletePopupImg}
            popupHeroText={popupHeroText}
            popupDescription={popupMessage}
            popBtn={true}
            btnText={"Delete"}
            secondaryBtn={true}
            btnTextSecondary={"Cancel"}
            btnClick={handleDeleteVendor}
            buyerBtn={true}
            buyerBtnOutline={true}
            btnClickSecondary={handleCloseDltConfirmation}
          />
        </Box>
      </Modal>

      {/* deletion */}
      <Modal open={openDlt}>
        <Box>
          <SuccessPopupDashboard
            popupImage={deletePopupImg}
            popupHeroText={popupHeroText}
            popupDescription={popupMessage}
            popBtn={true}
            btnText={"Okay"}
            loadingPrimaryBtn={loadingState}
            buyerBtn={true}
            buyerBtnOutline={true}
            btnClick={handleCloseDlt}
          />
        </Box>
      </Modal>
    </div>
  );
};

export default BuyerVendorsTab;
